/* Native Shopify lead-capture UX. This is not authentication or a secret-price API. */
(function () {
  'use strict';
  const VERSION = '2026-10-20-v1';
  const CACHE_KEY = 'limitless-coaching-pricing-v1';
  const PENDING_KEY = 'limitless-coaching-pricing-pending-v1';
  const PRICE_KEYS = ['private', 'camp', 'residency7', 'residency14', 'residency21', 'residency28'];
  const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  const PENDING_AGE = 30 * 60 * 1000;
  let current = null, returnedFromGate = false, initializedResponse = false, inMemoryOnly = false;
  function validPayload(value) {
    return !!value && value.version === VERSION && value.currency === 'AUD' && value.prices && PRICE_KEYS.every(key => Number.isFinite(value.prices[key]) && value.prices[key] > 0 && value.prices[key] < 1000000);
  }
  function read(storage, key) { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } }
  function storage(name) { try { return window[name]; } catch (_) { return null; } }
  function getStored() {
    for (const name of ['localStorage', 'sessionStorage']) {
      const cached = read(storage(name), CACHE_KEY);
      if (validPayload(cached) && Number.isFinite(cached.savedAt) && Date.now() - cached.savedAt >= 0 && Date.now() - cached.savedAt < MAX_AGE) return cached;
    }
    return null;
  }
  current = getStored();
  function getPrices() { return current ? Object.assign({}, current.prices) : null; }
  function money(value) { return Number.isFinite(value) ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(value).replace(/^\$/, 'A$') : 'Unlock pricing'; }
  function render(scope) {
    scope.querySelectorAll('[data-coaching-pricing]').forEach(panel => {
      panel.querySelector('[data-pricing-prompt]').hidden = !!current;
      panel.querySelector('[data-pricing-unlocked]').hidden = !current;
    });
    scope.querySelectorAll('[data-coaching-price]').forEach(el => {
      const value = current && current.prices[el.dataset.coachingPrice];
      const fraction = Number(el.dataset.coachingPriceFraction || 1);
      el.textContent = money(Number.isFinite(value) && fraction > 0 && fraction <= 1 ? value * fraction : null);
      el.classList.toggle('coaching-price-locked', !Number.isFinite(value));
    });
  }
  function initialize(scope) {
    if (!initializedResponse) {
      initializedResponse = true;
      const pending = read(storage('sessionStorage'), PENDING_KEY);
      const validPending = pending && typeof pending.formId === 'string' && pending.path === location.pathname && Number.isFinite(pending.at) && Date.now() - pending.at >= 0 && Date.now() - pending.at < PENDING_AGE;
      const form = validPending ? document.getElementById(pending.formId) : null;
      const response = form && form.querySelector('[data-coaching-pricing-response]');
      const error = form && form.querySelector('[data-pricing-server-error]');
      if (response || error) {
        returnedFromGate = true;
        // A contact success/error response is shared by every native contact form.
        // Do not turn a pricing request into a successful coaching enquiry.
        document.querySelectorAll('[data-menu-contact]').forEach(contact => {
          contact.querySelector('[data-contact-success]')?.remove();
          contact.querySelector('.lcm-contact-error:not([data-contact-validation])')?.remove();
          const fields = contact.querySelector('[data-contact-fields]'); if (fields) fields.hidden = false;
        });
        try { storage('sessionStorage')?.removeItem(PENDING_KEY); } catch (_) {}
        if (response && !error) {
          let payload; try { payload = JSON.parse(response.textContent); } catch (_) {}
          if (validPayload(payload)) {
            current = Object.assign({}, payload, { savedAt: Date.now() });
            let stored = false;
            for (const name of ['localStorage', 'sessionStorage']) {
              try { const target = storage(name); if (target) { target.setItem(CACHE_KEY, JSON.stringify(current)); stored = true; break; } } catch (_) {}
            }
            inMemoryOnly = !stored;
            if (!stored) document.querySelectorAll('[data-pricing-unlocked]').forEach(el => el.textContent = 'Pricing is unlocked on this page. Browser storage is unavailable, so you may need to enter your email again on another page.');
          }
        }
        // Restore the offering and information/enquiry context, without retaining Shopify's success flag.
        if (typeof pending.returnUrl === 'string') {
          try { const url = new URL(pending.returnUrl, location.origin); if (url.origin === location.origin && url.pathname === location.pathname) { url.searchParams.delete('contact_posted'); history.replaceState(history.state, '', url.pathname + url.search + url.hash); } } catch (_) {}
        }
      }
    }
    scope.querySelectorAll('[data-coaching-pricing-form]').forEach(form => {
      if (form.dataset.pricingReady) return; form.dataset.pricingReady = 'true';
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        const email = form.querySelector('[data-pricing-email]'); email.value = email.value.trim();
        const consent = form.querySelector('[data-pricing-marketing]').checked;
        form.querySelector('[data-pricing-consent-value]').value = consent ? 'Opted in to Limitless FMX experiences and upcoming dates by email; checkbox selected by visitor' : 'Not opted in';
        const returnUrl = new URL(location.href); returnUrl.searchParams.delete('contact_posted');
        const pending = { formId: form.id, path: location.pathname, returnUrl: returnUrl.pathname + returnUrl.search + returnUrl.hash, at: Date.now() };
        try {
          const target = storage('sessionStorage'); if (!target) throw new Error('STORAGE_UNAVAILABLE');
          target.setItem(PENDING_KEY, JSON.stringify(pending));
          if (!target.getItem(PENDING_KEY)) throw new Error('STORAGE_UNAVAILABLE');
        } catch (_) {
          event.preventDefault(); form.querySelector('[data-pricing-status]').textContent = 'This browser is blocking the temporary storage needed to unlock pricing. Allow site storage, or contact Pat through the enquiry form for prices.'; return;
        }
        // Keep Shopify's normal contact submission and CAPTCHA behavior intact.
        queueMicrotask(() => { if (!event.defaultPrevented) form.querySelector('[data-pricing-status]').textContent = 'Sending your pricing request…'; });
      });
    });
    render(scope);
    if (returnedFromGate) {
      const result = current ? scope.querySelector('[data-pricing-unlocked]') : scope.querySelector('[data-pricing-server-error]');
      if (result && !result.dataset.pricingFocused) { result.dataset.pricingFocused = 'true'; result.focus({ preventScroll: false }); }
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form && form.matches('form') && !form.hasAttribute('data-coaching-pricing-form') && form.querySelector('input[name="form_type"][value="contact"]')) {
      // An abandoned pricing attempt must not consume a later genuine enquiry confirmation.
      try { storage('sessionStorage')?.removeItem(PENDING_KEY); } catch (_) {}
    }
  }, true);
  window.LimitlessCoachingPricing = { initialize, getPrices, money, get returnedFromGate() { return returnedFromGate; }, validPayload };
  window.addEventListener('pageshow', () => { current = getStored() || (inMemoryOnly ? current : null); render(document); document.dispatchEvent(new CustomEvent('limitless:pricing-updated')); });
  window.addEventListener('storage', event => { if (event.key === CACHE_KEY) { current = getStored(); render(document); document.dispatchEvent(new CustomEvent('limitless:pricing-updated')); } });
  const ready = () => { initialize(document); document.dispatchEvent(new CustomEvent('limitless:pricing-updated')); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  document.addEventListener('shopify:section:load', ready);
})();
